export const locale = {
  menu: {
    accommodation: 'Accommodation',
    locations: 'Locations',
    blog: 'Blog',
    contact: 'Contact',
  },
  footer: {
    follow_us: 'Follow us',
    subscribe: 'Subscribe',
  },
  newsletter: {
    title: 'Be part of our community',
    description:
      'Subscribe to our newsletter and follow events, promotions, and activities you do not want to miss.',
    modal_title: 'Newsletter Signup',
    email_placeholder: 'Your email',
    consent_text: 'I agree to receive newsletter emails.',
    submit: 'Subscribe',
    sending: 'Sending...',
    success_localized: 'You have successfully subscribed to the newsletter!',
    success_short: 'Subscribed',
    success_fallback: 'If this address is eligible, it has been subscribed.',
    errors: {
      email_required: 'Email is required.',
      consent_required: 'Please confirm newsletter consent before continuing.',
      unable_to_complete: 'We could not complete subscription for this address.',
      validation: 'Please check your input and try again.',
      rate_limited: 'Too many attempts. Please try again later.',
      generic: 'There was an error while processing your request. Please try again.',
    },
    unsubscribe: {
      title: 'Newsletter Unsubscribe',
      loading: 'Processing your request...',
      success_fallback: 'You have been unsubscribed.',
      invalid: 'Invalid unsubscribe link.',
      error: 'We could not process your unsubscribe request. Please try again later.',
    },
  },
  validation: {
    email_missing: 'Please enter your email',
    newsletter_subscription_success:
      'You have successfully subscribed to the newsletter!',
    newsletter_subscription_error:
      'There was an error submiting your subscription to the newsletter. Please try again.',
  },
  copyright: {
    terms: 'Terms & Conditions',
    privacy: 'Privacy policy',
  },
  property: {
    description: 'Property description',
    images: 'Images',
    location: 'Location',
    submit: 'Submit your request',
    date: 'Date...',
    guests: 'Guests',
    total: 'Total',
    full_name: 'Full name',
    email_address: 'Email address',
    phone: 'Phone number (xxx-xxxx-xxx)',
    details: 'Details',
  },
  searchBox: {
    title: 'Accommodation name',
    location: 'Location',
    position: 'Position',
    type: 'Accommodation type',
    search: 'Search',
  },
  slider: {
    offers: 'Offers',
    details: 'Details',
    deals: 'All Deals',
  },
  propertyTypes: {
    all: 'All',
    hotels: 'Hotels',
    river_houses: 'River Houses',
    apartments: 'Apartments',
    camps: 'Camps',
  },
}
